import { ChartGroupDataValues } from "../interfaces/chart-data";
import {
    ChartDataGroupConfig,
    LineChartDataGroupConfigItem,
} from "../interfaces/chart-data-group-config";

export function getLabelForKey(
    groupConfig: ChartDataGroupConfig<
        ChartGroupDataValues,
        LineChartDataGroupConfigItem
    >,
    groupKey: string
) {
    return groupConfig[groupKey] != undefined
        ? groupConfig[groupKey].label
        : groupKey;
}

export function getCssClassForKey(
    groupConfig: ChartDataGroupConfig<
        ChartGroupDataValues,
        LineChartDataGroupConfigItem
    >,
    groupKey: string
) {
    return groupConfig[groupKey] != undefined
        ? groupConfig[groupKey].cssClass
        : "";
}
